import React from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink } from 'reactstrap';

export default class NavBar extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <div style={{minHeight: '60px'}}>
        <Navbar expand="md">
          <NavbarBrand style={{color: 'green', fontSize: '1.5em', WebkitTextStrokeColor: 'black', WebkitTextStrokeWidth: '0.3px'}} href="/">OHDSERVERS.NET</NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              {/* <NavItem>
                <NavLink className="navbarhoover" href="/discord">Discord Bot</NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink className="navbarhoover" href="/serversetup">ServerSetup</NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink className="navbarhoover" href="/events">Events</NavLink>
              </NavItem> */}
              {/* <NavItem>
                <NavLink className="navbarhoover" href="/videos">Videos</NavLink>
              </NavItem> */}
              {/* <NavItem>
                <NavLink  className="navbarhoover" href="/global">Stats</NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink className="navbarhoover" href="/about">About</NavLink>
              </NavItem>

            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}